import React from "react";
import {useParams} from "react-router";
import {Stack} from "@unibuddy/patron";
import useAuth from "shared/Auth/hooks/useAuth";

import {useChat} from "../providers/ChatProvider";
import {ChatHeader} from "../components/ChatHeader/ChatHeader";
import {useUniversity} from "../../UniversityProvider/UniversityProvider";

export function Chat() {
    const {conversationId: idFromParams} = useParams<{conversationId: string}>();
    const {conversationId: idFromContext} = useChat();
    const {authState} = useAuth();

    const user = authState?.me?.anyUser;
    const university = useUniversity();

    return (
        <Stack space="medium">
            <div>Mock Chat Component</div>
            <ChatHeader
                chatRulesOverride
                user={user}
                university={university}
            />

            <div>conversationId from params: {idFromParams}</div>
            <div>conversationId from context: {idFromContext}</div>
            <div>{idFromContext === idFromParams ? "ids match" : "ids don't match"}</div>
        </Stack>
    );
}
